module.exports = __webpack_public_path__ + "img/C3M.2853a78d.png";